module.exports = __webpack_public_path__ + "static/media/CabinSketch-Bold.e68a5f4b.ttf";